import { ReactNode } from 'react';

export enum SidebarStaticItemsIds {
    addEntity = 'addEntity',
    goToRecommendations = 'goToRecommendations',
    goToCampaigns = 'goToCampaigns',
    goToShowClients = 'goToShowClients',
    openReportsMenu = 'openReportsMenu',
    openLibraryMenu = 'openLibraryMenu',
    tools = 'tools',
    openInfoMenu = 'openInfoMenu'
}

export enum SidebarDynamicItemsIds {
    goToEdit = 'goToEdit'
}

export enum SecondLevelSidebarMenuIds {
    addEntity = 'addEntity',
    reportsMenu = 'reportsMenu',
    libraryMenu = 'libraryMenu',
    infoMenu = 'infoMenu',
    default = 'default'
}

export enum ThirdLevelSidebarMenuIds {
    addCampaign = 'addCampaign'
}

export interface SidebarItemsIds {
    static: SidebarStaticItemsIds[];
    dynamic: SidebarDynamicItemsIds[];
}

export interface SidebarState {
    expanded: boolean;
    selectedItemId?: SidebarStaticItemsIds | SidebarDynamicItemsIds;
    secondLevelMenuId?: SecondLevelSidebarMenuIds;
    thirdLevelMenuId?: ThirdLevelSidebarMenuIds;
}

export interface SidebarLinkData {
    login: string;
    ClientID: string;
    agencyLogin: string;
}

export interface AddEntityText {
    title: ReactNode;
    description: string;
}

export enum CampaignAndGroupSelectorEntityToSelectType {
    CAMPAIGN = 'Campaign',
    GROUP = 'Group',
    BANNER = 'Banners',
    PHRASE = 'Phrase',
    PHRASE_BETA = 'PhraseBeta',
    RETARGETING = 'Retargeting',
    FEED_FILTER = 'FeedFilter',
    USERS_PROFILE = 'UsersProfile'
}

export type AddEntityItem =
    | CampaignAndGroupSelectorEntityToSelectType.CAMPAIGN
    | CampaignAndGroupSelectorEntityToSelectType.GROUP
    | CampaignAndGroupSelectorEntityToSelectType.BANNER
    | CampaignAndGroupSelectorEntityToSelectType.PHRASE
    | CampaignAndGroupSelectorEntityToSelectType.PHRASE_BETA;
